import React, { Component } from "react";
import { connect } from "react-redux";
import * as ReactDOM from "react-dom";
import OneSchemaImporter from "@oneschema/react";

import {
  Container,
  KeyboardView,
  Row,
  Wrapper,
  Copy,
  DropzoneButton,
  Spin
} from "app/NativeComponents/common";
import { NewHeader, GhostButton } from "app/NativeComponents/snippets";
import {
  popSidePanel,
  uploadList,
  importLeads,
  addProgressBar,
  getCustomFields
} from "app/NativeActions";

class ImportListOneSchema extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      upload_list_info: null,
      isImporterOpen: true,
      loading: true,
      loadingRequest: false,
      customFields: null
    };
  }

  componentDidMount() {
    this.props.getCustomFields({
      token: this.props.token,
      type: "get_custom_fields",
      onSuccess: data => {
        console.log(data);
        this.setState({
          customFields: data.custom_fields.map(field => field.fields).flat()
        });
      }
    });
  }

  handleBack() {
    this.setState({ isImporterOpen: false });
    this.props.popSidePanel();
  }
  onLaunched = data => {
    // TODO handle launch
    this.setState({ loading: false });
  };

  onSuccess = data => {
    console.log(data);
    this.props.importLeads({
      token: this.props.token,
      payload: { ...data },
      onSuccess: results => {
        if (results.list && results.bulk_job_id) {
          this.props.addProgressBar({
            id: results?.bulk_job_id,
            type: "import",
            progress: results.completed_count,
            completed: results.completed,
            total_count: results.total_count,
            data: {
              list: results.list
            }
          });
        }

        this.setState({ loadingRequest: false });
        this.props.popSidePanel();
      },
      onLoading: () => {
        this.setState({ loadingRequest: true, isImporterOpen: false });
      },
      onError: error => {
        this.setState({ loadingRequest: false });
        this.props.popSidePanel();
      }
    });

    // TODO handle success
  };

  onCancel = () => {
    this.setState({ loading: false });
    // TODO handle cancel
  };

  onError = error => {
    this.setState({ loading: false });
    // TODO handle error
  };

  render() {
    const { isMobile, device, colors, custom_fields } = this.props;
    const { uploading, upload_list_info, loading, customFields } = this.state;
    const { onLaunched, onSuccess, onCancel, onError } = this;
    const customFieldsColumns = customFields
      ? customFields?.map(field => {
          return {
            key: "custom_field_" + field.value,
            label: field.label
          };
        })
      : [];

    return (
      <Container
        style={{
          display: "flex",
          alignSelf: "stretch",
          backgroundColor: colors.card_color
        }}
      >
        <NewHeader
          title={"Import List"}
          subtitle={""}
          leftButton={{
            icon: isMobile ? "arrow-back" : "close",
            onPress: () => {
              this.handleBack();
            }
          }}
        />
        {loading ? (
          <Wrapper
            style={{
              justifyContent: "center",
              alignItems: "center",
              height: "100%"
            }}
          >
            <Wrapper
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Spin size={"large"} />
              <Copy>Loading importer...</Copy>
            </Wrapper>
          </Wrapper>
        ) : null}
        {this.state.loadingRequest ? (
          <Wrapper
            style={{
              justifyContent: "center",
              alignItems: "center",
              height: "100%"
            }}
          >
            <Wrapper
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Spin size={"large"} />
              <Copy>Initializing import...</Copy>
            </Wrapper>
          </Wrapper>
        ) : null}
        {customFields ? (
          <OneSchemaImporter
            /* managing state from your application */
            isOpen={this.state.isImporterOpen}
            /* required config values */
            clientId="abe81333-f2ac-4d82-9331-6d74488a1aca"
            userJwt="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhYmU4MTMzMy1mMmFjLTRkODItOTMzMS02ZDc0NDg4YTFhY2EiLCJ1c2VyX2lkIjoiPFVTRVJfSUQ-In0.cNi8ybwgxd9YqZGPLLadkVVjkLK2VpSSUFQKZmtkwak"
            templateKey="dealmachine_properties_2025_07_14_125120"
            /* optional config values */
            importConfig={{ type: "local" }}
            devMode={true}
            className="oneschema-importer"
            templateOverrides={{
              columns_to_add: customFieldsColumns
            }}
            style={{
              position: "",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1000
            }}
            /* handling results */
            onLaunched={onLaunched}
            onSuccess={onSuccess}
            onCancel={onCancel}
            onError={onError}
          />
        ) : null}
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, customsettings }) => {
  const { token, user } = auth;

  const { colors } = settings;
  const { platform, device, isMobile } = native;
  const { custom_fields, custom_fields_loading } = customsettings;

  return {
    token,
    user,
    colors,
    device,
    isMobile,
    platform,
    custom_fields
  };
};

export default connect(mapStateToProps, {
  popSidePanel,
  uploadList,
  importLeads,
  addProgressBar,
  getCustomFields
})(ImportListOneSchema);
